import { DataTableColumnModel, DataTableItemsPerPageEnum, DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { DataTableNamesEnum } from 'app/shared/enums/datatable-names.enum';

const DOCUMENT_LIBRARY_TABLE_CONFIG: DataTableColumnModel[] = [
  { prop: 'fileName', name: 'label.document', linkedValue: true, minWidth: 600, width: 600, hasFilter: true, sortable: true, showFilterSearch: true},
  { prop: 'modifiedBy', name: 'label.modified_by', hasFilter: true, minWidth: 300, width: 300, sortable: true, showFilterSearch: true},
  { prop: 'modifiedAt', name: 'label.modified_date', minWidth: 300, width: 300, fieldType: "date", dateFormat: "MMM d, y", hasFilter: true, sortable: true, showFilterSearch: true},
  {
    prop: 'actions',
    name: 'label.actions',
    minWidth: 100, 
    width: 100,
    actionButtons: { delete: true },
  },
];

const DOCUMENT_LIBRARY_TABLE_STATE: DataTableStateModel = {
  sortingValue: {
    prop: '',
    dir: DataTableSortEnum.SORT_DESC
  },
  pageNumber: 1,
  showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10,
  gridName: DataTableNamesEnum.DOCUMENT_LIBRARY_DATATABLE,
  tableType: ''
};

export {
  DOCUMENT_LIBRARY_TABLE_CONFIG,
  DOCUMENT_LIBRARY_TABLE_STATE
}
